import { io } from 'socket.io-client';

const socketOrder = io('https://backend.washta.com/', {
    transports: ['polling'] // fallback if websocket fails
  });

export default socketOrder;